import { render, staticRenderFns } from "./ParametrosNotificacao.vue?vue&type=template&id=65b12f7a&scoped=true"
import script from "./ParametrosNotificacao.vue?vue&type=script&lang=js"
export * from "./ParametrosNotificacao.vue?vue&type=script&lang=js"
import style0 from "./ParametrosNotificacao.vue?vue&type=style&index=0&id=65b12f7a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b12f7a",
  null
  
)

export default component.exports